/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type HpRespPromoModulePrimaryOld_homepage$ref = any;
export type HpRespPromoModulePrimaryOld_homepage = {
    readonly promoPrimaryModule: ({
        readonly title?: string | null;
        readonly items?: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly link: string | null;
            readonly isLinkable: boolean | null;
            readonly imageUrl?: string | null;
            readonly mobileImageUrl?: string | null;
        } | null> | null;
    } & ({
        readonly title: string | null;
        readonly items: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly link: string | null;
            readonly isLinkable: boolean | null;
            readonly imageUrl?: string | null;
            readonly mobileImageUrl?: string | null;
        } | null> | null;
    } | {
        /*This will never be '% other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    })) | null;
    readonly " $refType": HpRespPromoModulePrimaryOld_homepage$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "HpRespPromoModulePrimaryOld_homepage",
    "type": "Homepage",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isMobile",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": "promoPrimaryModule",
            "name": "module",
            "storageKey": "module(type:\"promoPrimary\")",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "promoPrimary"
                }
            ],
            "concreteType": null,
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "type": "PromoModule",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "title",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "items",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PromoItem",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "cmsId",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "link",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isLinkable",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "condition": "isMobile",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "imageUrl",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "isMobile",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "mobileImageUrl",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'd10d786f2139c687e9f9437cdc3bf852';
export default node;
